import React from "react"
import { useTranslation } from "react-i18next"

import { RoomFormModel } from "features/room-management/types/RoomFormModel"
import { RoomFormTabType } from "features/room-management/types/RoomFormTabType"
import { RoomOverlay } from "widgets/room/room-overlay/RoomOverlay"

export interface EditRoomOverlayModel {
  roomFormModel: RoomFormModel
  onCancel?: () => void
  defaultTab?: RoomFormTabType
  isLoading?: boolean
  isSubmitting?: boolean
}

export interface EditRoomOverlayProps extends EditRoomOverlayModel {
  autoFocus?: boolean
}

export const EditRoomOverlay = React.memo((props: EditRoomOverlayProps) => {
  const { t } = useTranslation()
  return (
    <RoomOverlay
      id="edit-room-overlay"
      formID="edit-room-overlay-form"
      className="edit-room-overlay"
      headline={t("Room.Actions.Update")}
      prefix="room__edit"
      {...props}
    />
  )
})
